
import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { BtEvent } from '../../services/event.service';
import { HookType } from '../../services/hook.service';

import { MiscUtil } from '../../util/misc.util';

import { inject } from '@angular/core';

import { LibModulesModule } from '../../components/lib-modules.module';
import { BooktechAppService } from "../../services/booktech-app.service";

@Component({
    selector: 'btlib-page-tools',
    imports: [LibModulesModule],
    templateUrl: './tools.page.html',
    styleUrl: './tools.page.scss'
})
export class ToolsPage {

  bas = inject(BooktechAppService);

  route:ActivatedRoute = inject(ActivatedRoute);
  // qp:any = { }


  processing = false;


  constructor() {

    this.bas.us.checkActivatedRoute(this.route.snapshot);
    

    let qp =  this.route.snapshot.queryParams;


    if(this.bas.envtest) console.log("ToolsPage, route.snapshot: ", this.route.snapshot);
    

    this.bas.hs.on(
      HookType.WebToolsRequest, 
      (params) => this.processRequest(params)
    );

    this.bas.hs.trigger(HookType.WebToolsRequest, {
      queryParams: qp,
  
    })

  }

  ngOnInit(): void {
    
  }

  processRequest(params:any) {

    // this.bas.api.apiPageShowMessage(params.queryParams);

    return new Promise<boolean>((res, rej) => {

      let qp = params.queryParams;

      let action = qp["action"];
      // let toolsAction = qp["cbtools-tools-action"];


      let target = "/";
      let queryParams:any = { };

      for (let pn in qp) {
        if (!pn.startsWith("cbtools-option-")) continue;
        let name = pn.substring("cbtools-option-".length);
        queryParams[name] = qp[pn];
      }


      if(this.bas.envtest) console.log("target: " + target + ", queryParams: ", queryParams);

/*
      


      if (page) {

        target = "/" + page;

        
        if (page == "index") {
          target = "/";
        // } else if (page == "order/payment") {

        //   target = "/lib" + target; // /lib/order/payment/?id=dfdf
        } 
        else if (page == "confirmUser") {

          target =  "/lib/user/confirm";

          queryParams = {
            action: toolsAction
          }
        }


        
      }

      if (action) {
        if (action == "showNewPasswordDialog") {
          // TODO:TEST
          target = "/lib/user/password";

  

          return;
        }

      }



      // if(this.bas.envtest) 
        console.log("target: " + target + ", queryParams: ", queryParams);
      */

    });
  }
}



